import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { UNSAFE_expValNoExposure } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { LoadableAfterPaint } from '@confluence/loadable';
import { NthUserOrientation } from '@confluence/experiment-nth-user-orientation/entry-points/NthUserOrientation.ts';

const RovoAnnouncementSplashModalLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RovoAnnouncementSplashModal" */
				'@confluence/create-with-rovo-announcement-splash/entry-points/RovoAnnouncementSplashModal.ts'
			)
		).RovoAnnouncementSplashModal,
});

const ConnectorSetupModalHostLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConnectorSetupModalHost" */
				'@confluence/experiment-twcg-1489-cc-3p-connector-onboarding/entry-points/ConnectorSetupModalHost.ts'
			)
		).ConnectorSetupModalHost,
});

export const OnboardingComponentsLoader = (): React.JSX.Element | null => {
	if (isStableUIEnabledForTests()) {
		return null;
	}

	return (
		<>
			<ErrorBoundary attribution={Attribution.CE_MAU}>
				<NthUserOrientation />
			</ErrorBoundary>

			{fg('aifc_onboarding_ga_enabled') && (
				<ErrorBoundary attribution={Attribution.FLYWHEEL_FEATURE_DISCOVERY}>
					<RovoAnnouncementSplashModalLoadable />
				</ErrorBoundary>
			)}

			{/*
			 * No exposure is fired here. This always-mounted host only needs to know
			 * whether to be present; the real experiment exposure is fired by the
			 * trigger surfaces (sidebar / nav search) when the user actually engages.
			 */}
			{/* eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation */}
			{UNSAFE_expValNoExposure('twcg-1489-cc-3p-connector-onboarding', 'isEnabled', false) && (
				<ErrorBoundary attribution={Attribution.GROWTH_CFIND}>
					<ConnectorSetupModalHostLoadable />
				</ErrorBoundary>
			)}
		</>
	);
};
